var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nw-home"},[_c('div',{class:{ 'page-home': _vm.isHomePage }},[_c('NhHeader'),_c('main',[_vm._t("default")],2),_c('NhFooter'),_c('NhBackToTop')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }